exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tmq-ds6777_PrOpgpkXs4{display:inline-block}html[dir=ltr] .tmq-ds6777_PrOpgpkXs4{padding-right:3px}html[dir=rtl] .tmq-ds6777_PrOpgpkXs4{padding-left:3px}.tPfhWNnIvG75BMy4kl0DB{font-weight:600}", ""]);

// exports
exports.locals = {
	"recipientContent": "tmq-ds6777_PrOpgpkXs4",
	"groupOrDl": "tPfhWNnIvG75BMy4kl0DB"
};